import React from 'react';
import { ShieldCheck, Zap, RotateCcw, CheckCircle2 } from 'lucide-react';
export function Purchase() {
  return <section id="comprar" className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-72">
      <div className="bg-gradient-to-b from-trek-blackLight to-trek-black border-2 border-trek-orange rounded-3xl p-8 sm:p-12 text-center shadow-[0_0_50px_rgba(224,122,44,0.15)] relative overflow-hidden" data-id="element-73">
        {/* Background accent */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-trek-orange to-transparent" data-id="element-74"></div>

        <h2 className="text-4xl sm:text-5xl font-display text-white mb-6" data-id="element-75">
          ACCEDÉ AL PACK COMPLETO{' '}
          <span className="text-trek-orange" data-id="element-76">HOY MISMO</span>
        </h2>

        <p className="text-trek-beige text-lg mb-8 max-w-2xl mx-auto" data-id="element-77">
          Llevate los 6 tomos del Pack Trekking Pro + los 4 bonos exclusivos de
          regalo.
        </p>

        <div className="bg-trek-black border border-trek-brown rounded-2xl p-6 sm:p-8 mb-8 max-w-xl mx-auto" data-id="element-78">
          <div className="flex flex-col items-center justify-center mb-6" data-id="element-79">
            <span className="text-trek-beige/50 line-through text-2xl font-bold mb-2" data-id="element-80">
              $49.990 ARS
            </span>
            <div className="flex items-baseline gap-2 flex-wrap justify-center" data-id="element-81">
              <span className="text-trek-orange font-display text-4xl sm:text-5xl leading-none" data-id="element-82">
                $19.990
              </span>
              <span className="text-trek-orange font-bold text-lg" data-id="element-83">ARS</span>
            </div>
            <span className="bg-trek-orange/20 text-trek-orange px-3 py-1 rounded-full text-sm font-bold mt-4" data-id="element-84">
              Pago único — Acceso inmediato
            </span>
          </div>

          <ul className="text-left space-y-3 mb-8" data-id="element-85">
            <li className="flex items-center gap-3 text-trek-beige" data-id="element-86">
              <CheckCircle2 className="text-trek-orange flex-shrink-0" size={20} data-id="element-87" />
              <span data-id="element-88">
                <strong data-id="element-89">6 Tomos completos</strong> (PDF descargable)
              </span>
            </li>
            <li className="flex items-center gap-3 text-trek-beige" data-id="element-90">
              <CheckCircle2 className="text-trek-orange flex-shrink-0" size={20} data-id="element-91" />
              <span data-id="element-92">Bono 1: Checklist de trekking seguro</span>
            </li>
            <li className="flex items-center gap-3 text-trek-beige" data-id="element-93">
              <CheckCircle2 className="text-trek-orange flex-shrink-0" size={20} data-id="element-94" />
              <span data-id="element-95">Bono 2: Plan de entrenamiento</span>
            </li>
            <li className="flex items-center gap-3 text-trek-beige" data-id="element-96">
              <CheckCircle2 className="text-trek-orange flex-shrink-0" size={20} data-id="element-97" />
              <span data-id="element-98">Bono 3: Mapa de decisiones en ruta</span>
            </li>
            <li className="flex items-center gap-3 text-trek-beige" data-id="element-99">
              <CheckCircle2 className="text-trek-orange flex-shrink-0" size={20} data-id="element-100" />
              <span data-id="element-101">Bono 4: Atlas Argentino de trekking</span>
            </li>
          </ul>

          <a href="https://checkout.ebookpoint.shop/cart/59499318280273:1" target="_blank" rel="noopener noreferrer" className="block w-full py-5 text-2xl font-display bg-trek-orange hover:bg-trek-orangeLight text-white rounded-xl transition-all transform hover:scale-105 hover:shadow-[0_0_30px_rgba(224,122,44,0.4)] text-center" data-id="element-102">
            ⛰️ COMPRAR AHORA →
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-6 sm:gap-12 text-trek-beige/70" data-id="element-103">
          <div className="flex flex-col items-center gap-2" data-id="element-104">
            <ShieldCheck size={32} className="text-trek-brownLight" data-id="element-105" />
            <span className="text-sm font-medium" data-id="element-106">Pago Seguro</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-107">
            <Zap size={32} className="text-trek-brownLight" data-id="element-108" />
            <span className="text-sm font-medium" data-id="element-109">Acceso Inmediato</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-110">
            <RotateCcw size={32} className="text-trek-brownLight" data-id="element-111" />
            <span className="text-sm font-medium" data-id="element-112">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}